import { NavMarker } from 'react-rhumb';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function ViewError() {
  return /*#__PURE__*/_jsxs(ErrorMessage, {
    type: "error",
    children: [/*#__PURE__*/_jsx(NavMarker, {
      name: "PREVIEW_FAIL"
    }), /*#__PURE__*/_jsx(FormattedMessage, {
      message: "view.error"
    })]
  });
}